export class CanvasEventTool implements Autodesk.Viewing.ToolInterface {

    private viewer: Autodesk.Viewing.GuiViewer3D;
    private onClick: (x: number, y: number, tap: boolean) => void;
   
    constructor(viewer: Autodesk.Viewing.GuiViewer3D, onClick: (x: number, y: number, tap: boolean) => void) {
        this.viewer = viewer;
        this.onClick = onClick;
    }

    register(): void {
        console.log(`${this.getName()} registered`);
    }

    deregister(): void {
        console.log(`${this.getName()} deregistered`);
    }

    activate(name: string, viewerApi?: Autodesk.Viewing.GuiViewer3D): void {
        console.log(`${name} activated`);
    }

    deactivate(name: string): void {
        console.log(`${name} deactivated`);
    }

    update(): boolean { return false; }

    getName(): string {
        return "SmartDrawings.CanvasEventTool";
    }

    getNames(): string[] {
        return [this.getName()];
    }

    handleSingleTap(event): boolean {
        this.onClick(event.canvasX, event.canvasY, true);
        return false;
    }

    handleSingleClick(event: MouseEvent, button: number): boolean {
        this.onClick(event.clientX, event.clientY, false);
        return false;
    }

    getPriority(): number {
        return 100;
    }
}